/**
 * URLs dos assets do pacote shared (ícones etc.).
 * Em produção, os assets são copiados para /assets/shared/ pelo build do app.
 * Usa BASE_URL (Vite) para funcionar quando o app é publicado em subpath (ex.: /b2b/).
 */
const base =
  ((typeof import.meta !== 'undefined' &&
    (import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL) ??
  '') || '';
const assetsBase =
  base.endsWith('/') ? `${base}assets/shared` : `${base || '/'}assets/shared`;

// Forgot Password
export const iconEyeUrl = `${assetsBase}/forgotPassword/icon-eye.png`;
export const iconPersonUrl = `${assetsBase}/forgotPassword/icon-person.png`;

// Users management
export const iconSearchButton = `${assetsBase}/users/Icon-search-button-users.png`;
export const iconPersonButton = `${assetsBase}/users/Icon-person-button-users.png`;
export const iconDeleteTable = `${assetsBase}/users/Icon-delete-table-users.png`;
export const iconEditTable = `${assetsBase}/users/Icon-edit-table-users.png`;
export const iconAddTable = `${assetsBase}/users/Icon-add-table-users.png`;
export const iconPlusButton = `${assetsBase}/users/Icon-plus-button-users.png`;

// Groups
export const iconDeleteTableGroups = `${assetsBase}/groups/Icon-delete-table-groups.png`;
export const iconEditTableGroups = `${assetsBase}/groups/Icon-edit-table-groups.png`;
export const iconCheckWhiteModalGroups = `${assetsBase}/groups/Icon-check-white-modal-groups.png`;

// Users
export const iconCheckWhiteModalUsers = `${assetsBase}/users/Icon-check-white-modal-users.png`;

// QuestionBank
export const iconDeleteTableQuestionBank =
  `${assetsBase}/questionBank/Icon-delete-table-questionBank.png`;
export const iconEditTableQuestionBank =
  `${assetsBase}/questionBank/Icon-edit-table-questionBank.png`;

// Courses table
export const iconCalendarTableCourses =
  `${assetsBase}/courses/Icon-calendar-table-courses.png`;
export const iconPersonTableCourses =
  `${assetsBase}/courses/Icon-person-table-courses.png`;
export const iconEditTableCourses =
  `${assetsBase}/courses/Icon-edit-table-courses.png`;
export const iconViewTableCourses =
  `${assetsBase}/courses/Icon-view-table-courses.png`;
/** Ações de status na tabela de cursos (substitui visualizar por alteração de status). */
export const iconStatusTableCourses =
  `${assetsBase}/courses/Icon-alter-status-courses.png`;
export const iconDeleteTableCourses =
  `${assetsBase}/courses/Icon-delete-table-courses.png`;
export const iconSaveHeaderCourses =
  `${assetsBase}/courses/Icon-save-header-courses.png`;
export const iconArrowLeftHeaderCourses =
  `${assetsBase}/courses/Icon-arrow-left-header-courses.png`;
export const iconArrowRightHeaderCourses =
  `${assetsBase}/courses/Icon-arrow-right-header-courses.png`;
export const iconBookMenuCourses =
  `${assetsBase}/courses/Icon-book-menu-courses.png`;
export const iconCheckMenuCourses =
  `${assetsBase}/courses/Icon-check-menu-courses.png`;
export const iconCurriculumMenuCourses =
  `${assetsBase}/courses/Icon-curriculum-menu-courses.png`;
export const iconTargetingMenuCourses =
  `${assetsBase}/courses/Icon-targeting-menu-courses.png`;
export const iconBookStepCourses =
  `${assetsBase}/courses/Icon-book-step-courses.png`;
export const iconBookStep2Courses =
  `${assetsBase}/courses/Icon-book-step2-courses.png`;
export const iconBookYellowStep2Courses =
  `${assetsBase}/courses/Icon-book-yellow-step2-courses.png`;
export const iconModuleStep2Courses =
  `${assetsBase}/courses/Icon-module-step2-courses.png`;
export const iconFileStep2Courses =
  `${assetsBase}/courses/Icon-file-step2-courses.png`;
export const iconVideoStep2Courses =
  `${assetsBase}/courses/Icon-video-step2-courses.png`;
export const iconQuizStep2Courses =
  `${assetsBase}/courses/Icon-quiz-step2-courses.png`;
export const iconPlusStep2Courses =
  `${assetsBase}/courses/Icon-plus-step2-courses.png`;
export const iconPlusWhiteStep2Courses =
  `${assetsBase}/courses/Icon-plus-white-step2-courses.png`;
export const iconDeleteStep2Courses =
  `${assetsBase}/courses/Icon-delete-step2-courses.png`;
export const iconCongratulationStep2Courses =
  `${assetsBase}/courses/Icon-congratulation-step2-courses.png`;
export const iconTranslateStepCourses =
  `${assetsBase}/courses/Icon-translate-step-courses.png`;
export const iconLightBulbStepCourses =
  `${assetsBase}/courses/Icon-light-bulb-step-courses.png`;
export const iconUploadStepCourses =
  `${assetsBase}/courses/Icon-upload-step-courses.png`;
export const iconArrowDownStepCourses =
  `${assetsBase}/courses/Icon-arrow-down-step-courses.png`;
export const iconCloseModalCourses =
  `${assetsBase}/courses/Icon-close-modal-courses.png`;
export const iconVideoModalCourses =
  `${assetsBase}/courses/Icon-video-modal-courses.png`;
export const iconCheckWhiteModalCourses =
  `${assetsBase}/courses/Icon-check-white-modal-courses.png`;
export const iconVideoSmallModalCourses =
  `${assetsBase}/courses/Icon-video-small-modal-courses.png`;
export const iconFileModalCourses =
  `${assetsBase}/courses/Icon-file-modal-courses.png`;
export const iconFileSmallModalCourses =
  `${assetsBase}/courses/Icon-file-small-modal-courses.png`;
export const iconQuizSmallModalCourses =
  `${assetsBase}/courses/Icon-quiz-small-modal-courses.png`;
// Step 3 - Targeting & Publish
export const iconQuizStep3Courses =
  `${assetsBase}/courses/Icon-quiz-step3-courses.png`;
export const iconCheckStep3Courses =
  `${assetsBase}/courses/Icon-check-step3-courses.png`;
export const iconCheckSmallStep3Courses =
  `${assetsBase}/courses/Icon-check-small-step3-courses.png`;
export const iconGroupSmallStep3Courses =
  `${assetsBase}/courses/Icon-group-small-step3-courses.png`;
export const iconUsersSmallStep3Courses =
  `${assetsBase}/courses/Icon-users-small-step3-courses.png`;
export const iconSearchStep3Courses =
  `${assetsBase}/courses/Icon-search-step3-courses.png`;

// Login
export const iconLanguageSelector =
  `${assetsBase}/login/Icon-multi-linguagem-login.png`;

// Student dashboard — títulos do carrossel de cursos
export const iconStudentInProgress =
  `${assetsBase}/student/Icon-in-progress.png`;
export const iconStudentStart = `${assetsBase}/student/Icon-start.png`;
export const iconStudentWatch = `${assetsBase}/student/Icon-watch.png`;
export const iconStartVideoStudent =
  `${assetsBase}/student/Icon-start-video-student.png`;
/** Ranking top 3 — estrela gloss (PNG em `assets/student/icon-star.png`) */
export const iconStudentStar = `${assetsBase}/student/icon-star.png`;
/** Header do player de curso — lupa na busca */
export const iconStudentSearchHeader =
  `${assetsBase}/student/Icon-search-header.png`;
/** Header do player de curso — seta voltar no `backLink` */
export const iconStudentButtonHeader =
  `${assetsBase}/student/Icon-button-header.png`;
/** Header do player de curso — dropdown ao lado do nome do usuário */
export const iconStudentDropdown =
  `${assetsBase}/student/Icon-dropdown.png`;
/** Sidebar do player — ícones do syllabus (16×16 no UI) */
export const iconStudentSidebarVideo =
  `${assetsBase}/student/Icon-sidebar-video.png`;
export const iconStudentSidebarArchive =
  `${assetsBase}/student/Icon-sidebar-archive.png`;
export const iconStudentSidebarQuiz =
  `${assetsBase}/student/Icon-sidebar-quiz.png`;
export const iconStudentSidebarCheck =
  `${assetsBase}/student/Icon-sidebar-check.png`;
export const iconStudentSidebarDropdown =
  `${assetsBase}/student/Icon-sidebar-dropdown.png`;
/** Resultado do quiz — aprovado */
export const iconQuizSuccessStudent =
  `${assetsBase}/student/Icon-quiz-succes-student.png`;
/** Resultado do quiz — reprovado */
export const iconQuizErrorStudent =
  `${assetsBase}/student/Icon-quiz-error-student.png`;

// Gamification (admin — botão guardar)
export const iconSaveGamification =
  `${assetsBase}/gamification/Icon-save-gamification.png`;

// Admin Leaderboard Management
export const iconLeaderboardTotalActive =
  `${assetsBase}/leaderboard/Icon-total-active-leaderboard.png`;
export const iconLeaderboardAvgPoints =
  `${assetsBase}/leaderboard/Icon-avg-points-leaderboard.png`;
export const iconLeaderboardCoursesCompleted =
  `${assetsBase}/leaderboard/Icon-courses-completed-leaderboard.png`;
export const iconLeaderboardEngagementRate =
  `${assetsBase}/leaderboard/Icon-engagement-rate-leaderboard.png`;
export const iconLeaderboardSearch =
  `${assetsBase}/leaderboard/Icon-search-leaderboard.png`;
export const iconLeaderboardFirstPlace =
  `${assetsBase}/leaderboard/Icon-first-leaderboard.png`;
